import { useState, useMemo } from "react";

interface IUseLoadingData<TError> {
    loading: boolean;
    loadError?: TError;
    startLoading: () => void;
    loadSuccess: () => void;
    loadErrored: (error: TError) => void;
}

export type UseLoadingDataHook<TError = string> = () => IUseLoadingData<TError>;

export const useLoading = <TError = string>() => {
    const [loading, setLoading] = useState(false);
    const [loadError, setLoadError] = useState<TError>();

    return useMemo((): IUseLoadingData<TError> => {

        const startLoading = () => {
            setLoading(true);
            setLoadError(undefined);
        };

        const loadSuccess = () => {
            setLoading(false);
            setLoadError(undefined);
        };

        const loadErrored = (error: TError) => {
            setLoading(false);
            setLoadError(error);
        };

        return ({
            loading,
            loadError,
            startLoading,
            loadErrored,
            loadSuccess,
        });
    }, [loading, loadError]);
};
